import Backbone from 'backbone';
import Handlebars from 'handlebars';
import PhotoSwipeLightbox from 'PhotoSwipeLightbox';
import PhotoSwipe from 'PhotoSwipe';

import EventHub from '~/eventHub';
import guides_template from '~/templates/guides.handlebars';
import logindashboard from '~/templates/guidethemes/logindashboard.handlebars';
import activate2fa from '~/templates/guidethemes/activate2fa.handlebars';
import forgottenpassword from '~/templates/guidethemes/forgottenpassword.handlebars';
import viewcatsubcat from '~/templates/guidethemes/viewcatsubcat.handlebars';
import myreports from '~/templates/guidethemes/myreports.handlebars';
import otherreports from '~/templates/guidethemes/otherreports.handlebars';
import archivedreports from '~/templates/guidethemes/archivedreports.handlebars';
import viewreportemail from '~/templates/guidethemes/viewreportemail.handlebars';
import viewreportdashboard from '~/templates/guidethemes/viewreportdashboard.handlebars';
import viewreportinfo from '~/templates/guidethemes/viewreportinfo.handlebars';
import viewreportcomments from '~/templates/guidethemes/viewreportcomments.handlebars';
import viewreportstatus from '~/templates/guidethemes/viewreportstatus.handlebars';
import viewreportcollabs from '~/templates/guidethemes/viewreportcollabs.handlebars';
import viewreportpriority from '~/templates/guidethemes/viewreportpriority.handlebars';
import viewreportadminnotes from '~/templates/guidethemes/viewreportadminnotes.handlebars';
import viewreporttimeline from '~/templates/guidethemes/viewreporttimeline.handlebars';
import emailnotifreports from '~/templates/guidethemes/emailnotifreports.handlebars';
import emailnotifcomments from '~/templates/guidethemes/emailnotifcomments.handlebars';
import emailnotifnewuser from '~/templates/guidethemes/emailnotifnewuser.handlebars';
import notifbar from '~/templates/guidethemes/notifbar.handlebars';
import notifdashcatsubcat from '~/templates/guidethemes/notifdashcatsubcat.handlebars';
import notifdashwebpush from '~/templates/guidethemes/notifdashwebpush.handlebars';
import searchbar from '~/templates/guidethemes/searchbar.handlebars';
import searchbaruse from '~/templates/guidethemes/searchbaruse.handlebars';
import sidebarusers from '~/templates/guidethemes/sidebarusers.handlebars';
import newuser from '~/templates/guidethemes/newuser.handlebars';
import queryusers from '~/templates/guidethemes/queryusers.handlebars';
import editusers from '~/templates/guidethemes/editusers.handlebars';
import generatepassword from '~/templates/guidethemes/generatepassword.handlebars';
import deleteuser from '~/templates/guidethemes/deleteuser.handlebars';
import timelinelist from '~/templates/guidethemes/timelinelist.handlebars';
import timelinetable from '~/templates/guidethemes/timelinetable.handlebars';
import sidebarprofiles from '~/templates/guidethemes/sidebarprofiles.handlebars';
import admingen from '~/templates/guidethemes/admingen.handlebars';
import admincat from '~/templates/guidethemes/admincat.handlebars';
import adminsubcat from '~/templates/guidethemes/adminsubcat.handlebars';
import investigator from '~/templates/guidethemes/investigator.handlebars';
import adminmarket from '~/templates/guidethemes/adminmarket.handlebars';
import auditor from '~/templates/guidethemes/auditor.handlebars';
import comitteemember from '~/templates/guidethemes/comitteemember.handlebars';
import newprofile from '~/templates/guidethemes/newprofile.handlebars';
import customaccess from '~/templates/guidethemes/customaccess.handlebars';
import chatting from '~/templates/guidethemes/chatting.handlebars';
import notifchat from '~/templates/guidethemes/notifchat.handlebars';
import admincatsubcat from '~/templates/guidethemes/admincatsubcat.handlebars';
import changecatname from '~/templates/guidethemes/changecatname.handlebars';
import changecaticon from '~/templates/guidethemes/changecaticon.handlebars';
import changecatcollabs from '~/templates/guidethemes/changecatcollabs.handlebars';
import deactivatecat from '~/templates/guidethemes/deactivatecat.handlebars';
import activatecat from '~/templates/guidethemes/activatecat.handlebars';
import changesubcatname from '~/templates/guidethemes/changesubcatname.handlebars';
import changesubcatcollabs from '~/templates/guidethemes/changesubcatcollabs.handlebars';
import deactivatesubcat from '~/templates/guidethemes/deactivatesubcat.handlebars';
import activatesubcat from '~/templates/guidethemes/activatesubcat.handlebars';
import sendnews from '~/templates/guidethemes/sendnews.handlebars';
import newslist from '~/templates/guidethemes/newslist.handlebars';
import editdelnews from '~/templates/guidethemes/editdelnews.handlebars';
import sendtickets from '~/templates/guidethemes/sendtickets.handlebars';
import ticketslist from '~/templates/guidethemes/ticketslist.handlebars';
import graphsuser from '~/templates/guidethemes/graphsuser.handlebars';
import graphsuserexp from '~/templates/guidethemes/graphsuserexp.handlebars';
import graphsreps from '~/templates/guidethemes/graphsreps.handlebars';
import graphsrepsdate from '~/templates/guidethemes/graphsrepsdate.handlebars';
import graphsrepscat from '~/templates/guidethemes/graphsrepscat.handlebars';
import graphsrepssubcat from '~/templates/guidethemes/graphsrepssubcat.handlebars';
import graphsrepsexp from '~/templates/guidethemes/graphsrepsexp.handlebars';
import viewversions from '~/templates/guidethemes/viewversions.handlebars';
import changepassword from '~/templates/guidethemes/changepassword.handlebars';
import emailnotifs from '~/templates/guidethemes/emailnotifs.handlebars';
import myprofile2fa from '~/templates/guidethemes/myprofile2fa.handlebars';
import welcome from '~/templates/guidethemes/welcome.handlebars';

var GuidesView = Backbone.View.extend({
	className: 'Guides',
	guides: {
		welcome: {
			content: welcome,
			sidebarRoute: 'welcome',
			tabText: 'Manual Interactivo'
		},
		logindashboard: {
			content: logindashboard,
			sidebarRoute: 'logindashboard',
			tabText: 'Ingresar usuario y contraseña'
		},
		activate2fa: {
			content: activate2fa,
			sidebarRoute: 'activate2fa',
			tabText: 'Inicio de sesión con autentificación a 2 pasos (solo aplica si función esta activada)'
		},
		forgottenpassword: {
			content: forgottenpassword,
			sidebarRoute: 'forgottenpassword',
			tabText: '¿Cómo recuperar contraseña?'
		},
		viewcatsubcat: {
			content: viewcatsubcat,
			sidebarRoute: 'viewcatsubcat',
			tabText: 'Almacenamiento denuncias: Categorías y subcategorías'
		},
		myreports: {
			content: myreports,
			sidebarRoute: 'myreports',
			tabText: 'Mis reportes: Reportes asignados al administrador'
		},
		otherreports: {
			content: otherreports,
			sidebarRoute: 'otherreports',
			tabText: 'Otros reportes: Reportes a los que tengo acceso pero están asignados a un tercero'
		},
		archivedreports: {
			content: archivedreports,
			sidebarRoute: 'archivedreports',
			tabText: 'Reportes archivados: Reportes cerrados o descartados por algún administrador'
		},
		viewreportemail: {
			content: viewreportemail,
			sidebarRoute: 'viewreportemail',
			tabText: 'Acceso a denuncia: A través correo automático'
		},
		viewreportdashboard: {
			content: viewreportdashboard,
			sidebarRoute: 'viewreportdashboard',
			tabText: 'Acceso a denuncia: A través dashboard (ingreso en categoría, subcategoría y reporte)'
		},
		viewreportinfo: {
			content: viewreportinfo,
			sidebarRoute: 'viewreportinfo',
			tabText: 'Visualización de la denuncia: Descripción y adjuntos'
		},
		viewreportcomments: {
			content: viewreportcomments,
			sidebarRoute: 'viewreportcomments',
			tabText: 'Comunicación con el denunciante: Envió de mensajes y adjuntos'
		},
		viewreportstatus: {
			content: viewreportstatus,
			sidebarRoute: 'viewreportstatus',
			tabText: 'Estado de la denuncia: abierto, cerrado y descartado'
		},
		viewreportcollabs: {
			content: viewreportcollabs,
			sidebarRoute: 'viewreportcollabs',
			tabText: 'Asignación manual de la denuncia: Reenvió denuncia a terceros'
		},
		viewreportpriority: {
			content: viewreportpriority,
			sidebarRoute: 'viewreportpriority',
			tabText: 'Asignación prioridad de la denuncia: Alta, media y baja'
		},
		viewreportadminnotes: {
			content: viewreportadminnotes,
			sidebarRoute: 'viewreportadminnotes',
			tabText: 'Bitácora de la denuncia: Notas y documentación de la investigación'
		},
		viewreporttimeline: {
			content: viewreporttimeline,
			sidebarRoute: 'viewreporttimeline',
			tabText: 'Línea de tiempo de la denuncia: Medidas de control interno y auditoría'
		},
		emailnotifreports: {
			content: emailnotifreports,
			sidebarRoute: 'emailnotifreports',
			tabText: 'Notificaciones al correo: Nuevos reportes o reportes asignados'
		},
		emailnotifcomments: {
			content: emailnotifcomments,
			sidebarRoute: 'emailnotifcomments',
			tabText: 'Notificaciones al correo: Nuevos comentarios'
		},
		emailnotifnewuser: {
			content: emailnotifnewuser,
			sidebarRoute: 'emailnotifnewuser',
			tabText: 'Notificaciones al correo: Contraseñas y nuevos usuarios'
		},
		notifbar: {
			content: notifbar,
			sidebarRoute: 'notifbar',
			tabText: 'Notificaciones dashboard: Barra de notificaciones'
		},
		notifdashcatsubcat: {
			content: notifdashcatsubcat,
			sidebarRoute: 'notifdashcatsubcat',
			tabText: 'Notificaciones dashboard: Categorias, subcategorías y reportes'
		},
		notifdashwebpush: {
			content: notifdashwebpush,
			sidebarRoute: 'notifdashwebpush',
			tabText: 'Notificaciones web push'
		},
		searchbar: {
			content: searchbar,
			sidebarRoute: 'searchbar',
			tabText: 'Buscador de denuncias:'
		},
		searchbaruse: {
			content: searchbaruse,
			sidebarRoute: 'searchbaruse',
			tabText: 'Buscador de denuncias: Función operativa'
		},
		sidebarusers: {
			content: sidebarusers,
			sidebarRoute: 'sidebarusers',
			tabText: 'Usuarios:'
		},
		newuser: {
			content: newuser,
			sidebarRoute: 'newuser',
			tabText: 'Creación de nuevos usuarios'
		},
		queryusers: {
			content: queryusers,
			sidebarRoute: 'queryusers',
			tabText: 'Consultar usuarios'
		},
		editusers: {
			content: editusers,
			sidebarRoute: 'editusers',
			tabText: 'Edición usuarios: Nombre y correo electrónico'
		},
		generatepassword: {
			content: generatepassword,
			sidebarRoute: 'generatepassword',
			tabText: 'Generar nueva contraseña a un usuario'
		},
		deleteuser: {
			content: deleteuser,
			sidebarRoute: 'deleteuser',
			tabText: 'Eliminar un usuario'
		},
		timelinelist: {
			content: timelinelist,
			sidebarRoute: 'timelinelist',
			tabText: 'Línea de tiempo de un usuario: Medidas de control interno y auditoría'
		},
		timelinetable: {
			content: timelinetable,
			sidebarRoute: 'timelinetable',
			tabText: 'Línea de tiempo de un usuario: Visualización en tabla y exportación de informe de gestiones de un usuario'
		},
		sidebarprofiles: {
			content: sidebarprofiles,
			sidebarRoute: 'sidebarprofiles',
			tabText: 'Perfiles de usuario: Roles de acceso al sistema'
		},
		admingen: {
			content: admingen,
			sidebarRoute: 'admingen',
			tabText: 'Perfil recomendado: Administrador general.'
		},
		admincat: {
			content: admincat,
			sidebarRoute: 'admincat',
			tabText: 'Perfil recomendado: Administrador categoría'
		},
		adminsubcat: {
			content: adminsubcat,
			sidebarRoute: 'adminsubcat',
			tabText: 'Perfil recomendado: Administrador subcategoría'
		},
		investigator: {
			content: investigator,
			sidebarRoute: 'investigator',
			tabText: 'Perfil recomendado: Investigador'
		},
		adminmarket: {
			content: adminmarket,
			sidebarRoute: 'adminmarket',
			tabText: 'Perfil recomendado: Administrador mercadeo'
		},
		auditor: {
			content: auditor,
			sidebarRoute: 'auditor',
			tabText: 'Perfil recomendado: Auditoría'
		},
		comitteemember: {
			content: comitteemember,
			sidebarRoute: 'comitteemember',
			tabText: 'Perfil recomendado: Miembro comité de ética'
		},
		newprofile: {
			content: newprofile,
			sidebarRoute: 'newprofile',
			tabText: 'Creación de un nuevo perfil'
		},
		customaccess: {
			content: customaccess,
			sidebarRoute: 'customaccess',
			tabText: 'Personalización de accesos de un perfil'
		},
		chatting: {
			content: chatting,
			sidebarRoute: 'chatting',
			tabText: 'Envió de mensajes por el chat (incluyendo adjuntos)'
		},
		notifchat: {
			content: notifchat,
			sidebarRoute: 'notifchat',
			tabText: 'Notificaciones chat'
		},
		admincatsubcat: {
			content: admincatsubcat,
			sidebarRoute: 'admincatsubcat',
			tabText: 'Administrar categorías y subcategorías de denuncia:'
		},
		changecatname: {
			content: changecatname,
			sidebarRoute: 'changecatname',
			tabText: 'Administra categoría: Cambio de nombre de categoría'
		},
		changecaticon: {
			content: changecaticon,
			sidebarRoute: 'changecaticon',
			tabText: 'Administra categoría: Cambio de iconos de la categoría'
		},
		changecatcollabs: {
			content: changecatcollabs,
			sidebarRoute: 'changecatcollabs',
			tabText: 'Administra categoría: Asignar responsable o responsables por categoría'
		},
		deactivatecat: {
			content: deactivatecat,
			sidebarRoute: 'deactivatecat',
			tabText: 'Administra categoría: Desactivar categoría (todos los reportes se van archivado)'
		},
		activatecat: {
			content: activatecat,
			sidebarRoute: 'activatecat',
			tabText: 'Activación de categoría que este desactivada'
		},
		changesubcatname: {
			content: changesubcatname,
			sidebarRoute: 'changesubcatname',
			tabText: 'Administra subcategoría: Cambio de nombre de subcategoría'
		},
		changesubcatcollabs: {
			content: changesubcatcollabs,
			sidebarRoute: 'changesubcatcollabs',
			tabText: 'Administra subcategoría: Asignar responsable o responsables por subcategoría'
		},
		deactivatesubcat: {
			content: deactivatesubcat,
			sidebarRoute: 'deactivatesubcat',
			tabText: 'Administra subcategoría: Desactivar subcategoría (todos los reportes se van archivado)'
		},
		activatesubcat: {
			content: activatesubcat,
			sidebarRoute: 'activatesubcat',
			tabText: 'Activación de subcategoría que este desactivada'
		},
		sendnews: {
			content: sendnews,
			sidebarRoute: 'sendnews',
			tabText: 'Envió de noticias: Texto, enlace e imagen'
		},
		newslist: {
			content: newslist,
			sidebarRoute: 'newslist',
			tabText: 'Lista de noticias: Previsualización de noticias'
		},
		editdelnews: {
			content: editdelnews,
			sidebarRoute: 'editdelnews',
			tabText: 'Lista de noticias: Edición y eliminación de noticias'
		},
		sendtickets: {
			content: sendtickets,
			sidebarRoute: 'sendtickets',
			tabText: 'Reportar problema: Envió de tickets'
		},
		ticketslist: {
			content: ticketslist,
			sidebarRoute: 'ticketslist',
			tabText: 'Seguimiento a problemas: Seguimiento de tickets'
		},
		graphsuser: {
			content: graphsuser,
			sidebarRoute: 'graphsuser',
			tabText: 'Analíticas usuarios: Previsualización'
		},
		graphsuserexp: {
			content: graphsuserexp,
			sidebarRoute: 'graphsuserexp',
			tabText: 'Analíticas usuarios: Exportación informe en Excel'
		},
		graphsreps: {
			content: graphsreps,
			sidebarRoute: 'graphsreps',
			tabText: 'Analíticas reportes: Previsualización general'
		},
		graphsrepsdate: {
			content: graphsrepsdate,
			sidebarRoute: 'graphsrepsdate',
			tabText: 'Analíticas reportes: Filtro de fechas'
		},
		graphsrepscat: {
			content: graphsrepscat,
			sidebarRoute: 'graphsrepscat',
			tabText: 'Analíticas reportes: Filtro de categorías'
		},
		graphsrepssubcat: {
			content: graphsrepssubcat,
			sidebarRoute: 'graphsrepssubcat',
			tabText: 'Analíticas reportes: Filtro de subcategorías'
		},
		graphsrepsexp: {
			content: graphsrepsexp,
			sidebarRoute: 'graphsrepsexp',
			tabText: 'Analíticas reportes: Exportación gráficos (pdf), tabla de reportes e informe de de denuncias (excel)'
		},
		viewversions: {
			content: viewversions,
			sidebarRoute: 'viewversions',
			tabText: 'Visualización de informes'
		},
		changepassword: {
			content: changepassword,
			sidebarRoute: 'changepassword',
			tabText: 'Cambio de contraseña: Debe cumplir reglas de seguridad'
		},
		emailnotifs: {
			content: emailnotifs,
			sidebarRoute: 'emailnotifs',
			tabText: 'Recepción de notificaciones al correo'
		},
		myprofile2fa: {
			content: myprofile2fa,
			sidebarRoute: 'myprofile2fa',
			tabText: 'Habilitación autenticación a 2 pasos.'
		}
	},
	timeout: null,
	isWelcome: false,
	initialize: function() {
		
	},

	events: {
		'click .submiticon' : 'searchWelcome',
		'keyup #searchguidesinput' : 'searchGuide',
		'click .cancelsearch' : 'clearSearch',
	},

	render: function() {
		var handlebarsTemplate = Handlebars.template(guides_template);
		this.$el.html(handlebarsTemplate());
		this.attachEvents();
		return this;
		
	},

	attachEvents: function() {
		var that = this;
		this.listenTo(EventHub, 'guides:setGuide', data => {
			if(that.guides[data.id]){
				var handlebarsTemplate2 = Handlebars.template(that.guides[data.id].content);
				$("#guideContainer").html(handlebarsTemplate2());
				EventHub.trigger('sidebarView:setActive', '#guides?id='+that.guides[data.id].sidebarRoute);
    			var currentView = that.guides[data.id].tabText;
				if(data.id == 'welcome'){
					that.isWelcome = true;
					$('.topcontainer').hide();
				}
				else{
					that.isWelcome = false;
					$('.topcontainer').show();
				}
   				EventHub.trigger('header:setName', currentView);
			}
			else{
				that.isWelcome = true;
				var handlebarsTemplate2 = Handlebars.template(that.guides['welcome'].content);
				$("#guideContainer").html(handlebarsTemplate2());
				EventHub.trigger('sidebarView:setActive', '#guides?id='+that.guides['welcome'].sidebarRoute);
    			var currentView = that.guides['welcome'].tabText;
				$('.topcontainer').hide();
				that.$el.find('#searchwelcomeinput').on('keypress', function(e){
					if(e.key === "Enter") {
						e.preventDefault();
						that.searchWelcome();
					}
				});
   				EventHub.trigger('header:setName', currentView);
			}
			// Include Lightbox
			const lightbox = new PhotoSwipeLightbox({
				gallery: '.detalles',
				children: 'a',
				initialZoomLevel: 'fit',
  				secondaryZoomLevel: 1.5,
  				maxZoomLevel: 1.5,
				pswpModule: PhotoSwipe
			});
			lightbox.init();
		});
	},

	searchWelcome: function() {
		$('#searchguidesinput').val($('#searchwelcomeinput').val());
		$('.topcontainer').show();
		$('#searchguidesinput').focus();
		this.searchText();
	},

	searchGuide: function() {
		this.searchText();
	},

	clearSearch: function() {
		$('#searchguidesinput').val('');
		$('.foundguides-table').empty();
		$('.foundguides-table').hide();
		$('.noResults').hide();
		$('.totalofguides').empty();
		$('.totalofguides').hide();
		$('.searchloader').show();
		$('#searchTitle').hide();
		$('.cancelsearch').hide();
		$('#guideContainer').show();
		if(this.isWelcome){
			$('#searchwelcomeinput').val($('#searchguidesinput').val());
			$('.topcontainer').hide();
			$('#searchwelcomeinput').focus();
		}
	},
	
	getBestScoreIndex: function(scores) {
		var index = 0;
		var tempScore = 0;
		for(var i = 0; i < scores.length; ++i){
			if(tempScore < scores[i]){
				tempScore = scores[i];
				index = i;
			}
		}
		return index;
	},

	searchText: function(){
		$('#guideContainer').hide();
		$('#searchTitle').show();
		$('.searchloader').show();
		$('.totalofguides').hide();
		$('.cancelsearch').hide();
		$('.foundguides-table').empty();
		$('.noResults').hide();
		var val = $("#searchguidesinput").val();
		val = val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		var re = new RegExp(val, 'g');
		var that = this;
		clearTimeout(this.timeout);
		this.timeout = setTimeout(function () {
			if(val != ''){
				$('.searchloader').hide();
				var searchTerms = val.split(' ');
				for(var i = 0; i < searchTerms.length; ++i){
					if(searchTerms[i] == ''){
						searchTerms.splice(i, 1);
						--i;
					}
				}
				var score = [];
				var totalScore = 0;
				var guides = Object.keys(that.guides);
				guides.forEach((guide) => {
					if(guide != 'welcome'){
						var handlebarsTemplate = Handlebars.template(that.guides[guide].content);
						$("#searchContainer").html(handlebarsTemplate());
						var content = $("#searchContainer").text();
						var tempScore = 0;
						for(var i = 0; i < searchTerms.length; ++i){
							if(content.includes(searchTerms[i])){
								++tempScore;
							}
						}
						score.push(tempScore);
						totalScore += tempScore;
					}
				});
				$('.foundguides-table').show();
				if(totalScore > 0){
					$('.foundguides-table').append('<tr><th class="infotableheader item" key="tableheadernew">Guía</th> <th class="infotableheader item" key="tableheaderclosed">Título</th></tr>');
					var results = [];
					var totalr = 0;
					do{
						++totalr;
						var index = that.getBestScoreIndex(score);
						results.push(guides[index+1]);
						totalScore -= score[index];
						score[index] = 0;
					}
					while (totalScore > 0);
					for(var i = 0; i < results.length; ++i){
						$('.foundguides-table').append('<tr><td class="searhtableinfo"><a href="#guides?id='+that.guides[results[i]].sidebarRoute+'"><button type="button" class="btn btn-primary gotoreportbtn">Ver guía</button></a></td><td class="searhtableinfo searchtabledata">'+that.guides[results[i]].tabText+'</td></tr>');
					}
					$('.totalofguides').show();
					$('.totalofguides').text("Se encontraron " +totalr +" guías");
				}
				else{
					$('.totalofguides').show();
					$('.totalofguides').text("Se encontraron 0 guías");
					$('.noResults').show();
				}
				$('.cancelsearch').show();
			}
			else{
				that.clearSearch();
			}
		}, 1000);
	}
});
export default GuidesView;
